module.exports = __webpack_public_path__ + "img/gallery-icon-06.1554920a.png";